import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import axios from 'axios';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Input, { InputLabel } from 'material-ui/Input';
import { MenuItem } from 'material-ui/Menu';
import { FormControl, FormHelperText } from 'material-ui/Form';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import Select from 'material-ui/Select';

import {saveData} from './actions';

let id = 0;
function createData(rating, userbase) {
  id += 1;
  return { id, rating, userbase};
}

const data = [
  createData(7.0, 3008),
  createData(8.0, 1322),
  createData(8.5, 706),
  createData(9.0, 471),
  createData(9.5, 170),
  createData(10.0, 53),
];

class Question2 extends Component {

  constructor(props){
    super(props);

    this.state = {
      lowest: this.props.oarlow,
      highest: this.props.oarhigh,
      showPopulation: false,
      popCount: "~",
    };
  }

  handleChange = event => {

    if (event.target.name === "lowest"){
      if (this.state.highest < event.target.value){
        alert("Please select a value less than the highest OAR.")
      } else {
        // Correct
        this.setState({ [event.target.name]: event.target.value },function () {

        });
      }
    } else if (event.target.name === "highest"){

      if (this.state.lowest > event.target.value){
        alert("Please select a value higher than the lowest OAR.")
      } else {
        // Correct
        this.setState({ [event.target.name]: event.target.value },function () {

        });
      }
    }
  };

  onApplyFilter() {

    //oar_low: 0,oar_high:10,age_low:0,age_high: 65,pref_age:59,income: 0, education: 0,pref_fans: 0
    this.props.saveData(this.state.lowest,this.state.highest,0,75,0,0,0,0);
    this.props.changeRoute("/console/display/adhoc_filters/notifications")
  }

  render(){
    const { classes, theme, location } = this.props;
    const { showPopulation } = this.state;

    return(
      <div className={classes.root}>
        <Typography type="body2" color="inherit" className={classes.flex}>
          2. OAR Range
        </Typography>
        <br/>
        <Typography>You can check the user distribution of the OAR by tapping the button below:</Typography>
        <div className={classes.buttonDistribution}>
          <Button raised onClick={() => this.props.changeRoute("/console/display/adhoc_filters/distribution_2")} color="primary" align="center" className={classes.button}>See Distribution</Button>
        </div>
        <Typography>Select your preferred lowest and highest ratings from below:</Typography>
        <form className={classes.container} autoComplete="off">
          <FormControl className={classes.lowest}>
            <InputLabel htmlFor="lowest-rating">Lowest Rating</InputLabel>
            <Select
              value={this.state.lowest}
              onChange={this.handleChange}
              input={<Input name="lowest" id="lowest-rating" />}
            >
              <MenuItem value={7}>7</MenuItem>
              <MenuItem value={8}>8</MenuItem>
              <MenuItem value={8.5}>8.5</MenuItem>
              <MenuItem value={9}>9</MenuItem>
              <MenuItem value={9.5}>9.5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
            </Select>
          </FormControl>
          <FormControl className={classes.highest}>
            <InputLabel htmlFor="highest-rating">Highest Rating</InputLabel>
            <Select
              value={this.state.highest}
              onChange={this.handleChange}
              input={<Input name="highest" id="highest-rating" />}
            >
              <MenuItem value={7}>7</MenuItem>
              <MenuItem value={8}>8</MenuItem>
              <MenuItem value={8.5}>8.5</MenuItem>
              <MenuItem value={9}>9</MenuItem>
              <MenuItem value={9.5}>9.5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
            </Select>
          </FormControl>
        </form>
        <div className={classes.buttonNext}>
          <Button raised onClick={() => this.onApplyFilter()} color="primary" align="center" className={classes.button}>Apply Filter</Button>
          <Button raised onClick={() => this.props.changeRoute('/console/display/adhoc_filters')} color="primary" align="center" className={classes.button}>Select a different Filter</Button>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        oarlow: state.oar.low,
        oarhigh: state.oar.high,
        step: state.step.step,
    };
}

function matchDispatchToProps(dispatch){
  return {
    dispatch,
    saveData: bindActionCreators(saveData, dispatch),
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(Question2)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/Adhoc/scenes/Question2/index.js